'use strict';

import angular from 'angular';

function MemberAttributeResource($resource) {
  // id = personId;
  return $resource('/api/groups/:groupId/memberattributes/:id/:controller', {
    groupId: '@groupId', id: '@id'
  }, {
    queryMemberRel: {
      method: 'GET',
      isArray: true,
      params: { controller: 'memberreport' }
    },
    set: { method: 'PUT' }
  });
}

MemberAttributeResource.$inject = ['$resource'];

export default angular.module('georgeApp.memberAttributeSvc', [])
  .factory('MemAtrSvc', MemberAttributeResource)
  .name;
